import React from 'react';

import {Typography} from '@mui/material';
import {AddressUpdateModal, RegistrationDataDrawer} from '..';
import {useRegistrationUpdateSurface} from '../../hooks/useRegistrationUpdateSurface';

export function RegistrationUpdateSurface({isAnyHomeModalOpen}: {isAnyHomeModalOpen: boolean}) {
	const {
		modalMode,
		formattedAddress,
		formattedSuggestionAddress,
		isAddressUpdateModalOpen,
		isRegistrationDataDrawerOpen,
		dismissDrawer,
		handleCloseAddressUpdateModal,
		handleNavigateToAddressForm,
		handleNavigateToAddressList,
		handleNavigateToAddressFormWithCasa,
		handleConfirmConfirmation,
		handleConfirmFirstAccess,
		handleConfirmSuggestion,
		handleRejectSuggestion,
		isPrimaryActionLoading,
		isSecondaryActionLoading,
		isAddressUpdateActionPending,
	} = useRegistrationUpdateSurface({isAnyHomeModalOpen});

	if (!modalMode) return null;

	const shouldShowSubDescription =
		modalMode === 'firstAccess' ||
		modalMode === 'suggestion' ||
		(modalMode === 'confirmation' && formattedAddress);

	const activeSubDescriptionAddress =
		modalMode === 'suggestion' || modalMode === 'firstAccess'
			? formattedSuggestionAddress
			: formattedAddress;

	return (
		<>
			<AddressUpdateModal
				open={isAddressUpdateModalOpen}
				mode={modalMode}
				onClose={handleCloseAddressUpdateModal}
				onNavigateToAddressForm={handleNavigateToAddressForm}
				onNavigateToAddressList={handleNavigateToAddressList}
				onNavigateToAddressFormWithCasa={handleNavigateToAddressFormWithCasa}
				onConfirmConfirmation={handleConfirmConfirmation}
				onConfirmFirstAccess={handleConfirmFirstAccess}
				onConfirmSuggestion={handleConfirmSuggestion}
				onRejectSuggestion={handleRejectSuggestion}
				isPrimaryActionLoading={isPrimaryActionLoading}
				isSecondaryActionLoading={isSecondaryActionLoading}
				isActionsDisabled={isAddressUpdateActionPending}
				subDescription={
					shouldShowSubDescription ? (
						<Typography variant="body1" textAlign="center" fontWeight={700}>
							{activeSubDescriptionAddress}
						</Typography>
					) : undefined
				}
			/>
			<RegistrationDataDrawer open={isRegistrationDataDrawerOpen} onClose={dismissDrawer} />
		</>
	);
}
